import React from "react";
import { Outlet } from "react-router-dom";
import AdminLayoutShell from "../../admin/navigation/AdminLayoutShell";
import {
  partnerSidebarSections,
  PARTNER_PANEL_HOME,
  getPartnerPageTitle,
} from "./partnerNavigation";
import "../../admin/navigation/AdminShell.css";

const PartnerDashboardLayout = ({ children }) => {
  return (
    <AdminLayoutShell
      sections={partnerSidebarSections}
      homePath={PARTNER_PANEL_HOME}
      logoutRedirect="/login"
      titleGetter={getPartnerPageTitle}
    >
      {children ?? <Outlet />}
    </AdminLayoutShell>
  );
};

export default PartnerDashboardLayout;
